/* eslint-disable @typescript-eslint/no-explicit-any */

import { Load } from "@/components/load";
import { Button } from "@/components/ui/button";
import { useGetTermsQuery } from "@/services/generate-term/generate-term";
import { ContentContainer, PageLayout, PageTitle } from "components/layout";
import { Plus, RefreshCcw } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { columns } from "../components/columns";
import { DataTable } from "../components/data-table";
import { useFilterState } from "../filter/hooks/filterState";

export function GenerateTermList() {
  const navigate = useNavigate();
  const filterState = useFilterState();
  const { filters } = filterState || { filters: {} };

  const {
    data: terms,
    isLoading,
    isFetching,
    refetch,
  } = useGetTermsQuery({
    search: filters.search || "",
    store_code: filters.store_code || "",
    status: filters.status || "",
    start_date: filters.start_date || "",
    end_date: filters.end_date || "",
    orderBy: filters.orderBy || {},
    page: filters.meta?.page || 1,
    perPage: filters.meta?.perPage || 10,
  });

  if (isLoading) return <Load />;
  const { data, meta } = terms || { data: [], meta: {} };

  return (
    <PageLayout>
      <PageTitle title="Termo de Tesouraria" description="Solicite Termos" />
      <ContentContainer>
        <div className="flex flex-row gap-2 justify-end">
          <Button
            onClick={refetch}
            className=" hidden h-8 lg:flex mb-4"
            size="sm"
          >
            <RefreshCcw className="mr-2 h-4 w-4" /> Atualizar
          </Button>
          <Button
            onClick={() =>
              navigate("/retaguarda-de-loja/termo-de-tesouraria/criar")
            }
            className="hidden h-8 lg:flex mb-4"
            size="sm"
          >
            <Plus className="mr-2 h-4 w-4" /> Solicitar Termo
          </Button>
        </div>
        <DataTable data={data as any} columns={columns} meta={meta} isLoading={isFetching} />
      </ContentContainer>
    </PageLayout>
  );
}